import { api } from '@@/services//api';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<Alacaza.SigninResult, Alacaza.SigninInput>({
      query: (body) => ({
        url: `auth/login`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Users'],
    }),
    refresh: builder.mutation<Alacaza.SigninResult, void>({
      query: () => ({
        url: `auth/refresh`,
        method: 'POST',
      }),
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: `auth/logout`,
        method: 'POST',
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(api.util.resetApiState());
      },
    }),
    resetPassword: builder.mutation<void, { email: string }>({
      query: (body) => ({
        url: `auth/lost-password/request`,
        method: 'POST',
        body: {
          email: body.email,
          scope: 'partner',
        },
      }),
    }),
    changePassword: builder.mutation<
      Alacaza.User,
      { token: string; password: string }
    >({
      query: (body) => ({
        url: `auth/password/reset`,
        method: 'POST',
        body: {
          password: body.password,
          confirmPassword: body.password,
          resetKey: body.token,
        },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRefreshMutation,
  useLogoutMutation,
  useChangePasswordMutation,
  useResetPasswordMutation,
} = authApi;
